/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { combineReducers } from "redux";

import { globalReducer } from "./reducers";

import { gateWayManagementAPI } from "../services/api";
import { buildingsManagementAPI } from "../services/rbm-api";
import { fileServeApi } from "../services/file-service-api/fileServeApi";
import { softwareAPI } from "../services/software-details-api"; 

import { ViewTypeProps } from "../models";
import { remoteConnectAPI } from "../services/remote-connect-api";

export interface RootState {
  global: ViewTypeProps;
}

const rootReducer = combineReducers({
  global: globalReducer,
  [gateWayManagementAPI.reducerPath]: gateWayManagementAPI.reducer,
  [fileServeApi.reducerPath]: fileServeApi.reducer,
  [buildingsManagementAPI.reducerPath]: buildingsManagementAPI.reducer,
  [remoteConnectAPI.reducerPath]: remoteConnectAPI.reducer,
  [softwareAPI.reducerPath]: softwareAPI.reducer,
});

export default rootReducer;
